import { Inject } from 'inversify-props'
import type { MarketplaceServiceAdapter } from './adapter'
import { ConfiguracoesMarketplace } from '@/models'

export class IntegracaoMarketplaceUseCase {
	@Inject('MarketplaceServiceAdapter')
	private marketplaceAdapter!: MarketplaceServiceAdapter

	integrarProdutos = async (lojaId: string): Promise<void> =>
		this.marketplaceAdapter.integrarProdutos(lojaId)

	buscarConfiguracaoPorLoja = async (lojaId: string): Promise<ConfiguracoesMarketplace> =>
		this.marketplaceAdapter.findConfiguracoesPorLoja(lojaId)
}